
export default {
  DIAL_CALL: 'dial-call',
  INITIATE_CALL: 'initiate-call',

  TOGGLE_VIDEO: 'toggle-video',
  TOGGLE_AUDIO: 'toggle-audio',
  LOCK_CALL_BUTTON: 'lock-call-button',

  DIAL_PATIENT: 'dial',
  END_CALL: 'end-call',
  NO_ANSWER: 'no-answer',
  CALL_DROPPED: 'call-dropped',
  CALL_ACCEPTED: 'call-accepted',
  CALL_REJECTED: 'call-rejected',

  PEER_DISCONNECTED: 'peer-disconnected',
  PEER_RECONNECTED: 'peer-reconnected',
  ICE_CANDIDATE: 'ice-candidate',
  LOG_CALL_EVENT: 'log-call-event',
  RE_NEGOTIATE_OFFER: 'renegotiate-offer'
}
